import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { useCommentsMap } from './useCommentsMap'

export function useCtxCommentsMap() {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario, dimensionsQuery } = useSelector(filtersSelector)

  return useCommentsMap({
    companyId,
    budgetingScenarioId: budgetingScenario?.id,
    dimensions: dimensionsQuery
  })
}
